import React from 'react'
import Footer from '../../../components/Landing/Footer'
import { SEO } from '../../../components/SEO'

const ShareStory = () => {
  return (
    <>
    <SEO 
      title="Share Your Story - Teaching Experiences"
      description="Share your teaching stories and experiences with the WorldoTutor community. Help others learn from your classroom strategies and success stories."
      keywords="share story, teaching experience, classroom stories, teaching tips, education blog"
      url="/share-story"
      type="website"
      og={{
        type: 'website',
        siteName: 'WorldoTutor',
        locale: 'en_US',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'Share Your Story - WorldoTutor',
          width: 1200,
          height: 630
        }
      }}
      twitter={{
        card: 'summary_large_image',
        site: '@worldotutor',
        image: {
          url: '/imgi_1_favicon.png',
          alt: 'Share Your Story - WorldoTutor'
        }
      }}
    />
    <div className="p-8 container mx-auto font-sans">
      <h1 className="text-4xl font-bold mb-6">Share Your Story</h1>
      
      <p className="text-lg mb-4">
        This is one of the crucial verticals we've introduced recently. It provides you with a space to share your stories or experiences on how to teach as well as handle the classroom. It includes more practical instances and actionable suggestions based on real classroom stories.
      </p>

      <p className="text-lg mb-4">
        Furthermore, these don't have anything long or theoretical. It may be as small as something you told a student which encouraged or uplifted their confidence. These pieces of advice are great and need to be shared with the world.
      </p>

      <p className="text-lg mb-6">
        You can send us the teaching methodology or strategies you applied in a classroom. Interestingly, you can share everything and anything, viz. what worked for you and whatnot.
      </p>

      <div className="bg-slate-100 p-6 rounded-lg my-8">
        <h2 className="text-2xl font-semibold mb-4">You can share your story using the following structure:</h2>
        <ul className="list-disc list-inside space-y-2 text-lg">
          <li>What problems/challenges do you encounter?</li>
          <li>How did you resolve those problems?</li>
          <li>From where and how did you get your strategy or idea?</li>
          <li>How did you apply it?</li>
          <li>How did it change the situation?</li>
          <li>What were the final outcomes?</li>
        </ul>
      </div>

      <p className="text-lg mb-4">
        As we all know communicating through stories is an age-old ritual. It is because stories stick to our minds and are easier to grab or understand.
      </p>

      <p className="text-lg mb-4">
        So, share your stories or personal experiences and help others to conquer the teaching challenges. Kindly share it with us and we will publish it with your name.
      </p>

      <p className="text-xl font-semibold  mt-8">
        In short, this is an opportunity to leave a positive impact on the world in yet another fascinating way.
      </p>
    </div>
    <div className='bg-neutralBlack'>
        <Footer/>
    </div>
    </>
  )
}

export default ShareStory
